import React, { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationMessage } from '@/components';
import { useFlag } from '@/hooks';
import { StatusLayout } from '@/layout';
import { FeatureFlags } from '@/model/global/types';

const withMaintenanceCheck = <T extends PropsWithChildren<unknown>>(flag: FeatureFlags) => (Component: React.FC<T>) => (
  props: T,
): JSX.Element => {
  const isDisabled = useFlag(flag);
  return isDisabled ? (
    <StatusLayout status="awaiting" height={200}>
      <NotificationMessage severity="warning" title={<FormattedMessage id="common.messages.maintenance.title" />}>
        <FormattedMessage id="common.messages.maintenance.content" />
      </NotificationMessage>
    </StatusLayout>
  ) : (
    <Component {...props} />
  );
};

export default withMaintenanceCheck;
